import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DidProvider, DID_TYPE, DID, ReplaceWithExistingDidRequest } from 'voxloud-types/dist/models';
import { DidsService } from 'src/app/domains/dids/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-replace-with-extisting-did-popup',
  templateUrl: './replace-with-existing-did-popup.component.html',
  styleUrls: ['./replace-with-existing-did-popup.component.scss']
})
export class ReplaceWithExistingDidPopupComponent implements OnInit {
  public did: DID;
  public companyId: number;
  public form: UntypedFormGroup;
  public availableTypes = Object.keys(DID_TYPE);
  public availableProviders: Array<string>;
  public loading = {
    providers: false,
    submit: false
  };
  @Output() onReplaceDid: EventEmitter<string> = new EventEmitter();

  constructor(
    private activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private didsService: DidsService,
    private notification: NotificationService
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      newPhone: [null, [Validators.required]],
      type: [DID_TYPE.GEOGRAPHIC, [Validators.required]],
      provider: [this.did.provider, [Validators.required]],
      providerReference: [null]
    });
    this.getProviders();
  }

  getProviders() {
    this.loading.providers = true;
    this.didsService.getProviders().subscribe((res: [DidProvider]) => {
      this.availableProviders = res.map(provider => provider.name);
      this.loading.providers = false;
    }, () => {
      this.loading.providers = false;
    });
  }

  isFieldValid(name: string) {
    return (
      !this.form.get(name).valid && this.form.get(name).touched
    );
  }

  selectType(type: string) {
    this.form.get('type').setValue(type);
  }

  selectProvider(provider: DidProvider) {
    this.form.get('provider').setValue(provider.name);
  }

  onSubmit() {
    if (this.form.valid) {
      const value = this.form.value;
      let payload: ReplaceWithExistingDidRequest = {
        number: value.newPhone,
        did_type: value.type.toUpperCase(),
        provider: value.provider,
        provider_reference: value.providerReference
      }
      this.loading.submit = true;
      this.didsService.replaceWithExistingDid(this.companyId, this.did.id, payload).subscribe((res: string) => {
        this.onReplaceDid.emit(res);
        this.loading.submit = false;
        this.close();
      }, () => {
        this.loading.submit = false;
        this.close();
      }
      );
    }
  }

  getPhoneNumberToken() {
    if (!this.form.get("newPhone").value) {
      return "company.dids.replace-with-existing-did.popup.form.error.required";
    } else {
      return "company.dids.replace-with-existing-did.popup.form.new-phone.error-invalid";
    }
  }

  close() {
    this.activeModal.close();
  }
}
